// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

import i18n from '@/lang'

// 导入页面组件（懒加载方式，优化性能）
const HomeView = () => import('@/views/HomeView.vue')
const GroupIntroduction = () => import('@/views/GroupIntroduction.vue')
const PortLogistics = () => import('@/views/PortLogistics.vue')
const IndustrialBase = () => import('@/views/IndustrialBase.vue')
const CharacteristicTown = () => import('@/views/CharacteristicTown.vue')
const NewsCenter = () => import('@/views/NewsCenter.vue')
const DownloadCenter = () => import('@/views/DownloadCenter.vue')
const NewsDetails = () => import('@/views/NewsDetails.vue')
const ProjectDetails = () => import('@/views/ProjectDetails.vue')
const AboutUs = () => import('@/views/AboutUs.vue')

// 注册路由插件
Vue.use(VueRouter)

// 路由规则（path建议用kebab-case命名规范）
const routes = [
  {
    path: '/', // 首页默认路径
    name: 'HomeView',
    component: HomeView,
    // 替换：将硬编码标题改为语言包key（对应lang/zh.js、zh-hk.js、en.js中的nav.home）
    meta: { titleKey: 'nav.home', showInNav: true }
  },
  {
    path: '/group-introduction',
    name: 'GroupIntroduction',
    component: GroupIntroduction,
    meta: { titleKey: 'nav.groupIntroduction', showInNav: true }
  },
  {
    path: '/about-us', // 遵循kebab-case命名规范
    name: 'AboutUs', // 组件名风格统一
    component: AboutUs,
    meta: {
      titleKey: 'nav.aboutUs', // 对应语言包中的key（需在lang目录下的语言文件中添加）
      showInNav: false // 不显示在导航栏中
    }
  },
  {
    path: '/port-logistics',
    name: 'PortLogistics',
    component: PortLogistics,
    meta: { titleKey: 'nav.portLogistics', showInNav: true }
  },
  {
    path: '/industrial-base',
    name: 'IndustrialBase',
    component: IndustrialBase,
    meta: { titleKey: 'nav.industrialBase', showInNav: true }
  },
  {
    path: '/characteristic-town',
    name: 'CharacteristicTown',
    component: CharacteristicTown,
    meta: { titleKey: 'nav.characteristicTown', showInNav: true }
  },
  {
    path: '/news-center',
    name: 'NewsCenter',
    component: NewsCenter,
    meta: { titleKey: 'nav.newsCenter', showInNav: true }
  },
  {
    path: '/news-detail', // :id 是动态参数，用于传递资讯ID
    name: 'NewsDetails',
    component: NewsDetails,
    meta: {
      // titleKey: 'nav.newsDetail', // 需在语言包中添加该key（如“资讯详情”）
      showInNav: false // 详情页不显示在导航栏
    }
  },
  {
    path: '/project-detail/:id', // :id 是动态参数，用于传递资讯ID
    name: 'ProjectDetails',
    component: ProjectDetails,
    meta: {

      showInNav: false // 详情页不显示在导航栏
    }
  },
  {
    path: '/download-center',
    name: 'DownloadCenter',
    component: DownloadCenter,
    meta: { titleKey: 'nav.downloadCenter', showInNav: true }
  }
]

// 创建路由实例
const router = new VueRouter({
  mode: 'history', // 去掉URL中的#（需要后端配合配置）
  base: process.env.BASE_URL, // 基础路径（默认/）
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  // 调试：打印关键信息，定位问题（可临时保留）
  console.log('当前语言：', i18n.locale)
  console.log('语言包：', i18n.messages)
  console.log('解析titleKey：', i18n.t(to.meta.titleKey))

  if (to.meta.titleKey) {
    document.title = i18n.t(to.meta.titleKey) // 直接用i18n实例，而非原型链
  }
})


export default router